import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {MultiSelectItemsService} from "../../services/multiSelectItemsService/multi-select-items.service";

@Component({
  selector: 'app-multi-select-tool',
  templateUrl: './multi-select-square-tool.component.html',
  styleUrls: ['./multi-select-square-tool.component.scss']
})
export class MultiSelectSquareToolComponent implements OnInit {

  constructor(private cd: ChangeDetectorRef, private multiSelectItems: MultiSelectItemsService) { }

  public isActive = false;

  toggleMultiSelectStatus(){
    this.multiSelectItems.isMultiSelectActive$ = !this.isActive;
    this.cd.detectChanges();
  }

  ngOnInit() {
    this.multiSelectItems.isMultiSelectActive$.subscribe((val)=>{
      this.isActive = val;
    });

    this.initListeners();
  }

  private initListeners(){

  }

}
